// extracted by mini-css-extract-plugin
module.exports = {"loader-position":"_1GBtg","loaderPosition":"_1GBtg"};